import { PhotoCapture } from '../enums';
export const PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_REQUEST = `${PhotoCapture.PHOTO_CAPTURE}_GET_FRAUD_WARNING_DATA_REQUEST`;
export const PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_SUCCESS = `${PhotoCapture.PHOTO_CAPTURE}_GET_FRAUD_WARNING_DATA_SUCCESS`;
export const PHOTO_CAPTURE_UPDATE_FRAUD_WARNING_ACCEPT_VALUE = `${PhotoCapture.PHOTO_CAPTURE}_UPDATE_FRAUD_WARNING_ACCEPT_VALUE`;
export const photoCaptureGetFraudWarningDataAction = (coCode, taskId, language) => ({
    type: PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_REQUEST,
    payload: { coCode, taskId, language }
});
export const photoCaptureGetFraudWarningDataSuccessAction = (photoCaptureFraudWarningData) => ({
    type: PHOTO_CAPTURE_GET_FRAUD_WARNING_DATA_SUCCESS,
    payload: photoCaptureFraudWarningData
});
export const photoCaptureUpdateFraudWarningAcceptAction = (fraudWarningAccept) => ({
    type: PHOTO_CAPTURE_UPDATE_FRAUD_WARNING_ACCEPT_VALUE,
    payload: fraudWarningAccept
});
//# sourceMappingURL=photoCaptureGetFraudWarningAction.js.map